
// const generateServiceSlug = (title) => {
//   return title
//     .toLowerCase()
//     .replace(/[^\w\s-]/g, '')
//     .replace(/\s+/g, '-')
//     .replace(/-+/g, '-')
//     .trim();
// };

// export const servicesData = [
//   {
//     title: "Application & Licensing",
//     items: [
//       "Assistance in Application & Compliances of EPR, E-waste, Plastic, Battery, Tyre & Used Oil",
//       "BIS/CRS Registration",
//       "SIMS | PIMS | AIMS | CHIMS",
//       "Normal UMPC / Section-19 / Model Approval",
//       "Scomet Application",
//       "CDSCO Import Licence (Form MD-14 & MD-15) & Dual Use NOC",
//       "WPC / ETA Licence"
//     ],
//     icon: "fa-file-alt",
//     description: "Comprehensive assistance with all types of regulatory applications and licensing requirements"
//   },
//   {
//     title: "Certifications & Registrations",
//     items: [
//       "Chartered Engineering Certification",
//       "New IEC, MSME, GST, NSIC Registration",
//       "FSSAI / APEDA License",
//       "Import Authorization of Restricted Items",
//       "Registration from DGFT & MOEF",
//       "IceGate / AD Code Registration",
//       "AEO Registration",
//       "MOOWR Registration"
//     ],
//     icon: "fa-certificate",
//     description: "Professional certification and registration services for businesses of all sizes"
//   },
//   {
//     title: "Customs & Compliance",
//     items: [
//       "Authorization from SPCB for Scrap Import",
//       "Drawback / Section 74",
//       "EPCG / DEEC Bond Acceptance & Cancellation",
//       "Custom Consultation – Export & Import All Licenses",
//       "Central Insecticides Board Registration",
//       "BEE Registration",
//       "RoHS Certification"
//     ],
//     icon: "fa-clipboard-check",
//     description: "Expert guidance through customs procedures and regulatory compliance"
//   }
// ];

// export   const services = {
//     "assistance-in-application-compliances-of-epr-e-waste-plastic-battery-tyre-used-oil": {
//       title: "Assistance in Application & Compliances of EPR, E-waste, Plastic, Battery, Tyre & Used Oil",
//       content: [
//         "End-to-end support for Extended Producer Responsibility (EPR) compliance",
//         "Expert guidance on documentation and regulatory requirements",
//         "Assistance with e-waste, plastic waste, battery waste, tyre waste, and used oil regulations",
//         "Regular compliance monitoring and reporting",
//         "Liaison with regulatory authorities",
//         "Annual return filing and record maintenance"
//       ],
//       image: "/images/services/EPR E-Waste.jpeg",
//       icon: "♻️"
//     },
//     "biscrs-registration": {
//       title: "BIS/CRS Registration",
//       content: [
//         "Complete guidance on BIS certification process",
//         "Assistance with product testing at BIS-approved labs",
//         "Documentation preparation and submission",
//         "Factory inspection support",
//         "Liaison with BIS officials",
//         "Renewal and post-certification compliance"
//       ],
//       image: "/images/services/BISRegistration.jpeg",
//       icon: "🏷️"
//     },
//     "sims-pims-aims-chims": {
//       title: "SIMS | PIMS | AIMS | CHIMS",
//       content: [
//         "Registration assistance for import monitoring systems",
//         "Steel Import Monitoring System (SIMS) support",
//         "Paper Import Monitoring System (PIMS) guidance",
//         "Aluminum Import Monitoring System (AIMS) compliance",
//         "Copper Import Monitoring System (CHIMS) documentation",
//         "Pre-import filing and compliance management"
//       ],
//       image: "https://knnindia.co.in/uploads/newsfiles/STEEL-IMPORTS-21-12-2024.jpg",
//       icon: "📊"
//     },
//     "normal-umpc-section-19-model-approval": {
//       title: "Normal UMPC / Section-19 / Model Approval",
//       content: [
//         "Guidance on Unique Material Product Code (UMPC) registration",
//         "Section-19 approval assistance for restricted items",
//         "Model approval process management",
//         "Technical documentation preparation",
//         "Liaison with DGFT and other authorities",
//         "Post-approval compliance support"
//       ],
//       image: "/images/services/Restricted Items.webp",
//       icon: "📋"
//     },
//     "scomet-application": {
//       title: "Scomet Application",
//       content: [
//         "Expert classification of dual-use items",
//         "Complete SCOMET authorization assistance",
//         "Documentation preparation as per DGFT guidelines",
//         "End-to-end application processing",
//         "Liaison with government authorities",
//         "Compliance monitoring and reporting"
//       ],
//       image: "/images/services/Scomet Application.jpeg",
//       icon: "🛡️"
//     },
//     "cdsco-import-licence-form-md-14-md-15-dual-use-noc": {
//       title: "CDSCO Import Licence (Form MD-14 & MD-15) & Dual Use NOC",
//       content: [
//         "Medical device import license (MD-14/MD-15) assistance",
//         "Dual-use NOC application support",
//         "Documentation preparation as per CDSCO requirements",
//         "Clinical evaluation report preparation",
//         "Liaison with CDSCO officials",
//         "Post-license compliance management"
//       ],
//       image: "/images/services/CDSCO.jpg",
//       icon: "🏥"
//     },
//     "wpc-eta-licence": {
//       title: "WPC/ETA Licence",
//       content: [
//         "Wireless Planning & Coordination (WPC) approval assistance",
//         "Equipment Type Approval (ETA) process management",
//         "Testing coordination at authorized labs",
//         "Technical documentation preparation",
//         "Frequency spectrum allocation guidance",
//         "Renewal and modification support"
//       ],
//       image: "/images/services/WPC-ETA Licence.png",
//       icon: "📡"
//     },
//     "chartered-engineering-certification": {
//       title: "Chartered Engineering Certification",
//       content: [
//         "Assistance with chartered engineer certification",
//         "Documentation preparation and verification",
//         "Liaison with engineering institutions",
//         "Project certification support",
//         "Import/export certification guidance",
//         "Technical evaluation report preparation"
//       ],
//       image: "/images/services/Chartered Engineering Certification.jpeg",
//       icon: "🛠️"
//     },
//     "new-iec-msme-gst-nsic-registration": {
//       title: "New IEC, MSME, GST, NSIC Registration",
//       content: [
//         "Import Export Code (IEC) registration assistance",
//         "MSME/Udyam registration support",
//         "GST registration and compliance",
//         "NSIC registration for small industries",
//         "Document preparation and submission",
//         "Post-registration compliance guidance"
//       ],
//       image: "https://e7.pngegg.com/pngimages/725/47/png-clipart-government-of-india-ministry-of-micro-small-and-medium-enterprises-small-business-india-text-logo.png",
//       icon: "🏢"
//     },
//     "fssai-apeda-license": {
//       title: "FSSAI / APEDA License",
//       content: [
//         "FSSAI license registration for food businesses",
//         "APEDA registration for export of agricultural products",
//         "Documentation preparation as per regulatory requirements",
//         "Food safety compliance assistance",
//         "Inspection support and liaison",
//         "License renewal and modification"
//       ],
//       image: "/images/services/Food-Safety.webp",
//       icon: "🍎"
//     },
//     "import-authorization-of-restricted-items": {
//       title: "Import Authorization of Restricted Items",
//       content: [
//         "Special import license application assistance",
//         "ITC(HS) classification guidance",
//         "Documentation preparation for restricted items",
//         "Liaison with DGFT and other authorities",
//         "End-to-end application processing",
//         "Compliance monitoring"
//       ],
//       image: "/images/services/Restricted Items.webp",
//       icon: "🚫"
//     },
//     "registration-from-dgft-moef": {
//       title: "Registration from DGFT & MOEF",
//       content: [
//         "DGFT registration and licensing support",
//         "MOEF environmental clearance assistance",
//         "Documentation preparation as per requirements",
//         "Liaison with government authorities",
//         "Compliance monitoring and reporting",
//         "Renewal and modification support"
//       ],
//       image: "/images/services/import-export.jpeg",
//       icon: "🌿"
//     },
//     "icegate-ad-code-registration": {
//       title: "IceGate / AD Code Registration",
//       content: [
//         "ICEGATE registration for customs clearance",
//         "AD Code (Authorized Dealer Code) registration",
//         "Documentation preparation and submission",
//         "Troubleshooting and issue resolution",
//         "Digital signature certificate guidance",
//         "Post-registration support"
//       ],
//       image: "/images/services/AD Code Registraion.jpg",
//       icon: "💻"
//     },
//     "aeo-registration": {
//       title: "AEO Registration",
//       content: [
//         "Authorized Economic Operator (AEO) certification support",
//         "AEO T1, T2, and T3 program guidance",
//         "Documentation and process implementation",
//         "Internal control system setup",
//         "Audit preparation and support",
//         "Post-certification compliance"
//       ],
//       image: "/images/services/AEO.png",
//       icon: "🛃"
//     },
//     "moowr-registration": {
//       title: "MOOWR Registration",
//       content: [
//         "Manufacturing and Other Operations in Warehouse Regulations (MOOWR) assistance",
//         "License application support",
//         "Bond execution guidance",
//         "Compliance with warehouse operations",
//         "Record-keeping and reporting",
//         "Audit and inspection support"
//       ],
//       image: "/images/services/MOOWR Scheme.webp",
//       icon: "🏭"
//     },
//     "authorization-from-spcb-for-scrap-import": {
//       title: "Authorization from SPCB for Scrap Import",
//       content: [
//         "SPCB authorization for scrap import",
//         "Documentation preparation as per pollution control norms",
//         "Liaison with State Pollution Control Board",
//         "Environmental compliance guidance",
//         "Inspection support",
//         "Renewal and modification assistance"
//       ],
//       image: "/images/services/SPCB.webp",
//       icon: "♻️"
//     },
//     "drawback-section-74": {
//       title: "Drawback / Section 74",
//       content: [
//         "Duty drawback claim assistance",
//         "Section 74 refund processing",
//         "Documentation preparation and verification",
//         "Liaison with customs authorities",
//         "Maximization of refund amounts",
//         "Compliance with regulatory requirements"
//       ],
//       image: "/images/services/Drawback.webp",
//       icon: "💰"
//     },
//     "epcg-deec-bond-acceptance-cancellation": {
//       title: "EPCG / DEEC Bond Acceptance & Cancellation",
//       content: [
//         "Export Promotion Capital Goods (EPCG) scheme assistance",
//         "Duty Exemption Entitlement Certificate (DEEC) processing",
//         "Bond acceptance and execution",
//         "Export obligation fulfillment guidance",
//         "Bond cancellation support",
//         "Compliance monitoring"
//       ],
//       image: "/images/services/Export-Promotion-Capital-Goods-1.webp",
//       icon: "📜"
//     },
//     "custom-consultation-export-import-all-licenses": {
//       title: "Custom Consultation – Export & Import All Licenses",
//       content: [
//         "Comprehensive customs clearance guidance",
//         "Export/import license requirements consultation",
//         "Customs procedure optimization",
//         "Documentation review and verification",
//         "Duty calculation and minimization strategies",
//         "Regulatory compliance advisory"
//       ],
//       image: "/images/services/import-export.jpeg",
//       icon: "🌐"
//     },
//     "central-insecticides-board-registration": {
//       title: "Central Insecticides Board Registration",
//       content: [
//         "CIB registration for insecticides",
//         "Product registration assistance",
//         "Labeling requirements compliance",
//         "Documentation preparation and submission",
//         "Liaison with CIB officials",
//         "Post-registration compliance"
//       ],
//       image: "/images/services/Insecticides-License-Registration.jpg",
//       icon: "🐜"
//     },
//     "bee-registration": {
//       title: "BEE Registration",
//       content: [
//         "Bureau of Energy Efficiency (BEE) star labeling",
//         "Product testing coordination",
//         "Documentation preparation and submission",
//         "Compliance with energy efficiency standards",
//         "Liaison with BEE officials",
//         "Renewal and modification support"
//       ],
//       image: "/images/services/BEE.jpg",
//       icon: "⚡"
//     },
//     "rohs-certification": {
//       title: "RoHS Certification",
//       content: [
//         "Restriction of Hazardous Substances (RoHS) compliance",
//         "Product testing coordination",
//         "Documentation preparation",
//         "Material declaration support",
//         "Supply chain compliance guidance",
//         "Certification maintenance"
//       ],
//       image: "/images/services/Rohs.webp",
//       icon: "⚠️"
//     }
//   };

// export const allServices = servicesData.flatMap(category => 
//   category.items.map(item => ({
//     name: item,
//     category: category.title,
//     slug: generateServiceSlug(item),
//     icon: category.icon,
//     description: category.description
//   }))
// );

// export { generateServiceSlug };


// servicesData.js

// Utility function to generate slugs
const generateServiceSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
};

// Service categories data
const serviceCategories = [
  {
    title: "Application & Licensing",
    icon: "fa-file-alt",
    description: "Comprehensive assistance with all types of regulatory applications and licensing requirements"
  },
  {
    title: "Certifications & Registrations",
    icon: "fa-certificate",
    description: "Professional certification and registration services for businesses of all sizes"
  },
  {
    title: "Customs & Compliance",
    icon: "fa-clipboard-check",
    description: "Expert guidance through customs procedures and regulatory compliance"
  }
];

// Service items data
const serviceItems = [
  // Application & Licensing services
  {
    title: "Assistance in Application & Compliances of EPR, E-waste, Plastic, Battery, Tyre & Used Oil",
    category: "Application & Licensing",
    icon: "♻️",
    image: "/images/services/EPR E-Waste.jpeg",
    content: [
      "End-to-end support for Extended Producer Responsibility (EPR) compliance",
      "Expert guidance on documentation and regulatory requirements",
      "Assistance with e-waste, plastic waste, battery waste, tyre waste, and used oil regulations",
      "Regular compliance monitoring and reporting",
      "Liaison with regulatory authorities",
      "Annual return filing and record maintenance"
    ]
  },
  {
    title: "BIS/CRS Registration",
    category: "Application & Licensing",
    icon: "🏷️",
    image: "/images/services/BISRegistration.jpeg",
    content: [
      "Complete guidance on BIS certification process",
      "Assistance with product testing at BIS-approved labs",
      "Documentation preparation and submission",
      "Factory inspection support",
      "Liaison with BIS officials",
      "Renewal and post-certification compliance"
    ]
  },
  {
    title: "SIMS | PIMS | AIMS | CHIMS",
    category: "Application & Licensing",
    icon: "📊",
    image: "https://knnindia.co.in/uploads/newsfiles/STEEL-IMPORTS-21-12-2024.jpg",
    content: [
      "Registration assistance for import monitoring systems",
      "Steel Import Monitoring System (SIMS) support",
      "Paper Import Monitoring System (PIMS) guidance",
      "Aluminum Import Monitoring System (AIMS) compliance",
      "Copper Import Monitoring System (CHIMS) documentation",
      "Pre-import filing and compliance management"
    ]
  },
  {
    title: "Normal LMPC / Section-19 / Model Approval",
    category: "Application & Licensing",
    icon: "📋",
    image: "/images/services/Restricted Items.webp",
    content: [
      "Guidance on Unique Material Product Code (UMPC) registration",
      "Section-19 approval assistance for restricted items",
      "Model approval process management",
      "Technical documentation preparation",
      "Liaison with DGFT and other authorities",
      "Post-approval compliance support"
    ]
  },
  {
    title: "Scomet Application",
    category: "Application & Licensing",
    icon: "🛡️",
    image: "/images/services/Scomet Application.jpeg",
    content: [
      "Expert classification of dual-use items",
      "Complete SCOMET authorization assistance",
      "Documentation preparation as per DGFT guidelines",
      "End-to-end application processing",
      "Liaison with government authorities",
      "Compliance monitoring and reporting"
    ]
  },
  {
    title: "CDSCO Import Licence (Form MD-14 & MD-15) & Dual Use NOC",
    category: "Application & Licensing",
    icon: "🏥",
    image: "/images/services/CDSCO.jpg",
    content: [
      "Medical device import license (MD-14/MD-15) assistance",
      "Dual-use NOC application support",
      "Documentation preparation as per CDSCO requirements",
      "Clinical evaluation report preparation",
      "Liaison with CDSCO officials",
      "Post-license compliance management"
    ]
  },
  {
    title: "WPC / ETA Licence",
    category: "Application & Licensing",
    icon: "📡",
    image: "/images/services/WPC-ETA Licence.png",
    content: [
      "Wireless Planning & Coordination (WPC) approval assistance",
      "Equipment Type Approval (ETA) process management",
      "Testing coordination at authorized labs",
      "Technical documentation preparation",
      "Frequency spectrum allocation guidance",
      "Renewal and modification support"
    ]
  },

  // Certifications & Registrations services
  {
    title: "Chartered Engineering Certification",
    category: "Certifications & Registrations",
    icon: "🛠️",
    image: "/images/services/Chartered Engineering Certification.jpeg",
    content: [
      "Assistance with chartered engineer certification",
      "Documentation preparation and verification",
      "Liaison with engineering institutions",
      "Project certification support",
      "Import/export certification guidance",
      "Technical evaluation report preparation"
    ]
  },
  {
    title: "New IEC, MSME, GST, NSIC Registration",
    category: "Certifications & Registrations",
    icon: "🏢",
    image: "https://e7.pngegg.com/pngimages/725/47/png-clipart-government-of-india-ministry-of-micro-small-and-medium-enterprises-small-business-india-text-logo.png",
    content: [
      "Import Export Code (IEC) registration assistance",
      "MSME/Udyam registration support",
      "GST registration and compliance",
      "NSIC registration for small industries",
      "Document preparation and submission",
      "Post-registration compliance guidance"
    ]
  },
  {
    title: "FSSAI / APEDA License",
    category: "Certifications & Registrations",
    icon: "🍎",
    image: "/images/services/Food-Safety.webp",
    content: [
      "FSSAI license registration for food businesses",
      "APEDA registration for export of agricultural products",
      "Documentation preparation as per regulatory requirements",
      "Food safety compliance assistance",
      "Inspection support and liaison",
      "License renewal and modification"
    ]
  },
  // {
  //   title: "Import Authorization of Restricted Items",
  //   category: "Certifications & Registrations",
  //   icon: "🚫",
  //   image: "/images/services/Restricted Items.webp",
  //   content: [
  //     "Special import license application assistance",
  //     "ITC(HS) classification guidance",
  //     "Documentation preparation for restricted items",
  //     "Liaison with DGFT and other authorities",
  //     "End-to-end application processing",
  //     "Compliance monitoring"
  //   ]
  // },
  {
    title: "Import Authorization of Restricted Items Registration from DGFT & MOEF",
    category: "Certifications & Registrations",
    icon: "🌿",
    image: "/images/services/import-export.jpeg",
    content: [
      "DGFT registration and licensing support",
      "MOEF environmental clearance assistance",
      "Documentation preparation as per requirements",
      "Liaison with government authorities",
      "Compliance monitoring and reporting",
      "Renewal and modification support"
    ]
  },
  {
    title: "IceGate / AD Code Registration",
    category: "Certifications & Registrations",
    icon: "💻",
    image: "/images/services/AD Code Registraion.jpg",
    content: [
      "ICEGATE registration for customs clearance",
      "AD Code (Authorized Dealer Code) registration",
      "Documentation preparation and submission",
      "Troubleshooting and issue resolution",
      "Digital signature certificate guidance",
      "Post-registration support"
    ]
  },
  {
    title: "AEO Registration",
    category: "Certifications & Registrations",
    icon: "🛃",
    image: "/images/services/AEO.png",
    content: [
      "Authorized Economic Operator (AEO) certification support",
      "AEO T1, T2, and T3 program guidance",
      "Documentation and process implementation",
      "Internal control system setup",
      "Audit preparation and support",
      "Post-certification compliance"
    ]
  },
  {
    title: "MOOWR Registration",
    category: "Certifications & Registrations",
    icon: "🏭",
    image: "/images/services/MOOWR Scheme.webp",
    content: [
      "Manufacturing and Other Operations in Warehouse Regulations (MOOWR) assistance",
      "License application support",
      "Bond execution guidance",
      "Compliance with warehouse operations",
      "Record-keeping and reporting",
      "Audit and inspection support"
    ]
  },

  // Customs & Compliance services
  {
    title: "Authorization from SPCB for Scrap Import",
    category: "Customs & Compliance",
    icon: "♻️",
    image: "/images/services/SPCB.webp",
    content: [
      "SPCB authorization for scrap import",
      "Documentation preparation as per pollution control norms",
      "Liaison with State Pollution Control Board",
      "Environmental compliance guidance",
      "Inspection support",
      "Renewal and modification assistance"
    ]
  },
  {
    title: "Drawback / Section 74",
    category: "Customs & Compliance",
    icon: "💰",
    image: "/images/services/Drawback.webp",
    content: [
      "Duty drawback claim assistance",
      "Section 74 refund processing",
      "Documentation preparation and verification",
      "Liaison with customs authorities",
      "Maximization of refund amounts",
      "Compliance with regulatory requirements"
    ]
  },
  {
    title: "EPCG / DEEC Bond Acceptance & Cancellation",
    category: "Customs & Compliance",
    icon: "📜",
    image: "/images/services/Export-Promotion-Capital-Goods-1.webp",
    content: [
      "Export Promotion Capital Goods (EPCG) scheme assistance",
      "Duty Exemption Entitlement Certificate (DEEC) processing",
      "Bond acceptance and execution",
      "Export obligation fulfillment guidance",
      "Bond cancellation support",
      "Compliance monitoring"
    ]
  },
  {
    title: "Custom Consultation – Export & Import All Licenses",
    category: "Customs & Compliance",
    icon: "🌐",
    image: "/images/services/import-export.jpeg",
    content: [
      "Comprehensive customs clearance guidance",
      "Export/import license requirements consultation",
      "Customs procedure optimization",
      "Documentation review and verification",
      "Duty calculation and minimization strategies",
      "Regulatory compliance advisory"
    ]
  },
  {
    title: "Central Insecticides Board Registration",
    category: "Customs & Compliance",
    icon: "🐜",
    image: "/images/services/Insecticides-License-Registration.jpg",
    content: [
      "CIB registration for insecticides",
      "Product registration assistance",
      "Labeling requirements compliance",
      "Documentation preparation and submission",
      "Liaison with CIB officials",
      "Post-registration compliance"
    ]
  },
  {
    title: "BEE Registration",
    category: "Customs & Compliance",
    icon: "⚡",
    image: "/images/services/BEE.jpg",
    content: [
      "Bureau of Energy Efficiency (BEE) star labeling",
      "Product testing coordination",
      "Documentation preparation and submission",
      "Compliance with energy efficiency standards",
      "Liaison with BEE officials",
      "Renewal and modification support"
    ]
  },
  {
    title: "RoHS Certification",
    category: "Customs & Compliance",
    icon: "⚠️",
    image: "/images/services/Rohs.webp",
    content: [
      "Restriction of Hazardous Substances (RoHS) compliance",
      "Product testing coordination",
      "Documentation preparation",
      "Material declaration support",
      "Supply chain compliance guidance",
      "Certification maintenance"
    ]
  }
];

// Transform service items into categorized structure for servicesData
const servicesData = serviceCategories.map(category => ({
  ...category,
  items: serviceItems
    .filter(service => service.category === category.title)
    .map(service => service.title)
}));

// Transform service items into object structure for services
const services = serviceItems.reduce((acc, service) => {
  const slug = generateServiceSlug(service.title);
  return {
    ...acc,
    [slug]: {
      title: service.title,
      content: service.content,
      image: service.image,
      icon: service.icon
    }
  };
}, {});

// Create allServices array
const allServices = serviceItems.map(service => ({
  name: service.title,
  category: service.category,
  slug: generateServiceSlug(service.title),
  icon: serviceCategories.find(cat => cat.title === service.category).icon,
  description: serviceCategories.find(cat => cat.title === service.category).description
}));

export {
  generateServiceSlug,
  servicesData,
  services,
  allServices
};